// extracted by mini-css-extract-plugin
export default {"root":"LoginSettings_root__WovUE","fields":"LoginSettings_fields__V2nIC","footer":"LoginSettings_footer__4ZMFa"};